import { TextEllipsis } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { WorkHistoryCompanyProps as Props } from './types';
import { getEmploymentType, getWorkHistoryCompanyDisplayInfo } from './utils';

export const WorkHistoryCompany = memo(({ className, item }: Props) => {
  const employmentType = getEmploymentType(item);
  const { displayName, color } = getWorkHistoryCompanyDisplayInfo(item);

  return (
    <Styled.Wrapper
      className={classnames('WorkHistoryCompany', className)}
      sx={SX.root}
    >
      <TextEllipsis
        w={employmentType ? '80%' : '99%'}
        variant="body2"
        color={color}
        fontWeight={700}
      >
        {displayName}
      </TextEllipsis>
    </Styled.Wrapper>
  );
});

WorkHistoryCompany.displayName = 'WorkHistoryCompany';
